// MUI components
import { useEffect, useState, useContext } from 'react'
import { IntakeContext } from '../context/IntakeContext'
import styled from 'styled-components'

import { toast } from 'react-toastify'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import FormField from 'components/FormField'
import Link from '@mui/material/Link'
import Icon from '@mui/material/Icon'
import HelpIcon from '@mui/icons-material/Help'
import CancelIcon from '@mui/icons-material/Cancel'

import CheckRoundedIcon from '@mui/icons-material/CheckRounded'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { IconButton, Tooltip, Fade } from '@mui/material'

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox'
import SoftButton from 'components/SoftButton'

import { OnboardingTile } from './OnboardingTile'

const StyledMSB = styled.div`
  text-align: center;
  position: relative;
  padding: 16px;
  height: 100%;
  cursor: pointer;
  border: 2px solid #e5e5e5;
  background: ${(props) => (props.active ? '#eeeeee' : '#fff')};
  color: #212121;
  border-radius: 0.75rem;
  transition: 0.2s all ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &:hover {
    border: 2px solid #a3a7aa;
    background: #f5f5f5;
  }

  > h6,
  h5 {
    color: #212121;
    letter-spacing: 0.3px;
    font-weight: 600;
    line-height: 1.4;
    margin: 0;
  }

  > span {
    border-radius: 50%;
    height: 1.5em;
    width: 1.5em;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;

    &.yesIcon {
      color: #4caf50;
      background-color: #dbefdc;
    }
    &.noIcon {
      color: #fd5c70;
      background-color: #fedee2;
    }
  }
`

const OnboardingDivorceDates = ({
  id,
  preHeader,
  header,
  subHeader,
  helpText,
  handleNext,
}) => {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)

  return (
    <Box sx={{ textAlign: 'left' }}>
      <Box>
        <Typography variant="subtitle1" fontSize={{ xs: '16px', sm: '20px' }}>
          {preHeader || ''}
        </Typography>
      </Box>
      <Box mb={1}>
        <Typography variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
          {header || "Let's start with your basic information:"}
          {helpText !== '' ? (
            <Tooltip
              TransitionComponent={Fade}
              title={
                helpText || 'This helps us calculate your retirement benefits'
              }
              placement="top"
              color="info"
            >
              <IconButton size="small" color="dark">
                <HelpIcon sx={{ marginTop: '-6px' }} />
              </IconButton>
            </Tooltip>
          ) : (
            <></>
          )}
        </Typography>
      </Box>

      <SoftBox component="form" px={1} py={2}>
        <Grid container columnSpacing={1}>
          <Box mt={3} mb={2}>
            <Typography variant="body1Medium">
              Marriage Date with Former Spouse
            </Typography>
          </Box>
          <Grid item xs={12} mb={2}>
            {renderMuiFormField({
              autoFocus: false,
              id: 'familyDivorcedMarriageStartDate',
              placeholder: '',
              inputType: 'splitdate',
              value: intakeState.familyDivorcedMarriageStartDate || '',
              onChange: (familyDivorcedMarriageStartDate) =>
                updateIntakeStateAtKey({ familyDivorcedMarriageStartDate }),
            })}
          </Grid>
          <Box mt={3} mb={2}>
            <Typography variant="body1Medium">
              Divorce Date with Former Spouse
            </Typography>
          </Box>
          <Grid item xs={12} mb={2}>
            {renderMuiFormField({
              autoFocus: false,
              id: 'familyDivorcedMarriageEndDate',
              placeholder: '',
              inputType: 'splitdate',
              value: intakeState.familyDivorcedMarriageEndDate || '',
              onChange: (familyDivorcedMarriageEndDate) =>
                updateIntakeStateAtKey({ familyDivorcedMarriageEndDate }),
            })}
          </Grid>
        </Grid>
      </SoftBox>
    </Box>
  )
}

export default OnboardingDivorceDates
